<div *ngIf="showAoUpsell">
    <div class="form-check form-check-wrapper ao-upsell-container">
        <label class="form-check-label plain-slim">
            <input type="checkbox" class="form-check-input" name="createAoUpsell" [(ngModel)]="createAoUpsell"
                   [ngModelOptions]="{standalone: true}" (change)="setCreateAoUpsell()">
            <span translate="cart.checkout.ao.subscribe.save.label" class="ao-upsell-label"></span>
        </label>
        <div class="margin-left-24">
            <label *ngIf="createAoUpsell && shippingCycleTypes?.length" class="margin-top-4">
                <span *ngIf="!!selectedShippingCycleTypeMsg" [innerHTML]="selectedShippingCycleTypeMsg"></span>
                <a class="d-block" *ngIf="!isEditingCycle" (click)="isEditingCycle = true" translate="cart.checkout.ao.change.cycle.type"
                   [attr.data-testid]="'cart.checkout.ao.change.cycle.type'"></a>
                <select *ngIf="isEditingCycle" [(ngModel)]="selectedShippingCycleType"
                        name="cart.field.ShippingCycleType.id" (change)="onShippingCycleTypeChange()" class="form-select">
                    <option *ngFor="let shippingCycleType of shippingCycleTypes; trackBy: trackByFn"
                            [ngValue]="shippingCycleType">{{ shippingCycleType.description }}
                    </option>
                </select>
            </label>
            <div *ngIf="createAoUpsell && aoUpsellSubtotal > 0" class="save-estimate">
                <span translate="cart.checkout.ao.subscribe.save.estimated"></span><span class="fw-bold"> {{aoUpsellSubtotal | usanacurrency | async}}</span>
            </div>
            <div *ngIf="createAoUpsell && totalIoReward > 0" class="save-estimate ior-message">
                <i class="fa-solid fa-sparkles margin-right-8"></i>
                <span translate="cart.checkout.ao.ior.save"></span><span class="fw-bold"> {{(totalIoReward) | usanacurrency | async}}</span>
            </div>
        </div>
    </div>
    <div class="save-description">*<span translate="cart.checkout.ao.subscribe.save.desc"></span></div>
</div>
